module.exports = __webpack_public_path__ + "media/images/user-male-silhouette-c375c6e38064718aab1df8935e2ac118.svg";